<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img
          class="solutionDetailTitle1"
          src="../../static/images/solutionText6.png"
        />
        <br />
        <img
          class="solutionDetailTitle2"
          src="../../static/images/solutionText7.png"
        />
        <!--
        <div
          class="solutionDetailText"
        >北斗“天枢”公共交通智慧安全立体防控平台是全国首例公共交通智能安防平台，已落地深圳、广州、苏州、无锡等地。平台建成集指挥调度、侦查研判、立体防控、警务管理等为一体的主动安全管理闭环，实现“情-指-勤-行-督”的一体化融合，致力于让公共交通更安全。</div>
        -->
        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              轨道交通智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              北斗“天枢”公共交通智慧安全立体防控平台是全国首例公共交通智能安防平台，已落地深圳、广州、苏州、无锡等地。平台建成集指挥调度、侦查研判、立体防控、警务管理等为一体的主动安全管理闭环，实现“情-指-勤-行-督”的一体化融合，致力于让公共交通更安全。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic7.jpg"
            />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic8.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              公交智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              为解决城市公交个人极端行为、扒窃等事件频发的问题，有效整合数据资源，降低安全风险发生几率，提高公交行业安保和公安信息化应对能力，建设一个集公交行业车辆管控、公交行业从业人员管理、公交内保巡查巡检及风险隐患管理，实现公交综合态势一图感知，汇集人、车、地、物，形成在大数据、云计算、物联网等新技术大背景下的情指一体、情勤一体、情行一体的公交立体防控平台。
            </div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              公共交通智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              为解决城市公共交通个人极端行为、扒窃等事件频发的问题，有效整合数据资源，降低安全风险发生几率，提高公共交通场所安保和公安信息化应对能力，建设一个集行业车辆管控、风险隐患管理、一图感知公共交通综合态势及车辆、人员轨迹分析的立体防控平台，形成在大数据、云计算、物联网等新技术大背景下的情指一体、情勤一体、情行一体的情报研判体系、可视化扁平化指挥系统、信息共享协同作战的新机制。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic9.jpg"
            />
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic10.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              机场智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              机场智慧安全立体防控平台基于安防中枢的风控引擎、轨迹引擎、档案引擎等技术，补齐人防和物防存在的短板，实现涉恐安全、违禁物品、群体事件等风险自动感知，重点人员、重点车辆、重点物品的全面管控，对治安内保、净空、空防、出入境等进行全面监管，满足活动保障、常态处置、应急指挥场景下资源协同、流程可视、决策智能，打造持续的平安民航和机场安防一体化综合管控能力，创建平安机场。
            </div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              铁路智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              铁路智慧安全立体防控平台旨在解决治安流窜犯罪管控难、治安安全风险识别不足的现状，构建一个安全、泛在、互联、智能的物联感知网，构建铁路大数据平台，形成一体化数据闭环，达到铁路交通治安管理大数据平台支撑实战的目的。构建完善的智能打防管控体系，搭建保障指挥、客流分析、全息档案、轨迹分析、智能安检、围界管理等业务应用，形成站车路态势实时感知、多维风险预警防控、人员精准打击、勤务高效协作的警务新模式，以降低犯罪率，实现平安站车路。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic11.jpg"
            />
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">
              边防智慧安全立体防控平台
            </div>
            <div class="solutionDetailSecondText">
              为解决防范设备匮乏、数据资源分散、人防精力有限的问题，减少涉外案事件、辖区暴恐案事件、涉恐人员从边境地区潜入潜出等治安事件，边防智慧安全立体防控平台通过科技提升边防工作质效，以安防中枢为基础，以人防+技防为手段，建设侦查研判、应急指挥、风险分析等子系统，实现非法屯居、越界捕捞等违法违规行为提前预判、应急处突联防联控，减轻边境工作人员工作压力，让打击违法、违规工作更加精准，实现边境地区安全稳定发展。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic12.jpg"
            />
          </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {

  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail3.vue